<template>
    <v-container fluid>
        <!-- GrowthTask Dialog -->
        <v-dialog v-model="growthTaskDialog" scrollable>
            <v-card tile>
                <v-toolbar flat dark color="primary">
                    <v-btn icon dark @click="closeGrowthTaskDialog">
                        <v-icon>close</v-icon>
                    </v-btn>
                    <v-toolbar-title>Growth Task</v-toolbar-title>
                    <v-spacer></v-spacer>
                    <v-btn
                        icon
                        dark
                        @click="goToGrowthTaskDetail(selectedGrowthTaskNodeId)"
                    >
                        <v-icon>launch</v-icon>
                    </v-btn>
                </v-toolbar>
                <v-card-text class="mx-0 px-0">
                    <GrowthTaskDetailComponent
                        v-if="selectedGrowthTaskNodeId"
                        :growthTaskNodeId="selectedGrowthTaskNodeId"
                        v-on:growthTask-items-updated="refreshGrowthTaskList"
                        v-on:item-deleted="onGrowthTaskDeleted"
                    ></GrowthTaskDetailComponent>
                </v-card-text>
            </v-card>
        </v-dialog>

        <v-row>
            <!-- Task table -->
            <v-col cols="12" class="pt-0">
                <v-hover>
                    <template v-slot="{ hover }">
                        <v-card :elevation="hover ? 6 : 1">
                            <v-container fluid>
                                <v-data-table
                                    :headers="headers"
                                    :loading="
                                        $apollo.queries.salesOrderPlant.loading
                                    "
                                    :items="
                                        salesOrderPlant.salesOrderGrowthTaskSet
                                            .edges
                                    "
                                    item-key="node.id"
                                    disable-pagination
                                    hide-default-footer
                                >
                                    <template
                                        v-slot:item.departement="{ item }"
                                    >
                                        <span
                                            v-if="
                                                item.node.growthTask
                                                    .currentGrowthTaskPhase
                                            "
                                            >{{
                                                item.node.growthTask
                                                    .currentGrowthTaskPhase
                                                    .greenhouseDepartmentSection
                                                    .greenhouseDepartment
                                                    .greenhouse.name
                                            }}
                                            -
                                            {{
                                                item.node.growthTask
                                                    .currentGrowthTaskPhase
                                                    .greenhouseDepartmentSection
                                                    .greenhouseDepartment.name
                                            }}
                                            -
                                            {{
                                                item.node.growthTask
                                                    .currentGrowthTaskPhase
                                                    .greenhouseDepartmentSection
                                                    .name
                                            }}</span
                                        >
                                    </template>
                                    <template
                                        v-slot:item.node.growthTask.potSize.potSizeCm="{
                                            item
                                        }"
                                    >
                                        <span
                                            >{{
                                                item.node.growthTask.potSize
                                                    .potSizeCm
                                            }}
                                            cm</span
                                        >
                                    </template>
                                    <template
                                        v-slot:item.node.growthTask.salesStartDate="{
                                            item
                                        }"
                                    >
                                        <v-chip
                                            small
                                            dark
                                            color="grey"
                                            v-if="
                                                item.node.growthTask
                                                    .totalInventory <= 0
                                            "
                                            >Closed</v-chip
                                        >
                                        <v-chip
                                            small
                                            color="error"
                                            dark
                                            v-else-if="
                                                item.node.growthTask
                                                    .isReadyToSell &&
                                                    item.node.growthTask
                                                        .salesEndDate < today
                                            "
                                            >Sales ({{
                                                calculateDaysBetweenDays(
                                                    today,
                                                    item.node.growthTask
                                                        .salesEndDate
                                                ) - 1
                                            }}
                                            days over)</v-chip
                                        >
                                        <v-chip
                                            small
                                            color="orange"
                                            dark
                                            v-else-if="
                                                item.node.growthTask
                                                    .isReadyToSell &&
                                                    item.node.growthTask
                                                        .salesStartDate <= today
                                            "
                                            >Sales ({{
                                                calculateDaysBetweenDays(
                                                    item.node.growthTask
                                                        .salesEndDate,
                                                    today
                                                ) + 1
                                            }}
                                            days left)</v-chip
                                        >
                                        <v-chip
                                            small
                                            color="success"
                                            dark
                                            v-else
                                            >Growing ({{
                                                calculateDaysBetweenDays(
                                                    item.node.growthTask
                                                        .salesStartDate,
                                                    today
                                                )
                                            }}
                                            days left)</v-chip
                                        >
                                    </template>

                                    <template
                                        v-slot:item.node.growthTask.createdAt="{
                                            item
                                        }"
                                    >
                                        <span>{{
                                            item.node.growthTask.createdAt
                                                | moment("YYYY-MM-DD")
                                        }}</span>
                                    </template>
                                    <template
                                        v-slot:item.node.growthTask.growthStartDate="{
                                            item
                                        }"
                                    >
                                        <span>{{
                                            item.node.growthTask
                                                .growthStartDate
                                                | moment("YYYY-[W]WW")
                                        }}</span>
                                    </template>
                                    <template v-slot:item.action="{ item }">
                                        <!-- <v-btn
                                            outlined
                                            rounded
                                            small
                                            color="primary"
                                            @click="goToGrowthTaskDetail(item.node)"
                                        >View</v-btn>-->
                                        <v-btn
                                            icon
                                            color="primary"
                                            @click="
                                                openGrowthTaskDialog(
                                                    item.node.growthTask
                                                )
                                            "
                                        >
                                            <v-icon>remove_red_eye</v-icon>
                                        </v-btn>
                                        <v-btn
                                            icon
                                            color="primary"
                                            @click="
                                                goToGrowthTaskDetail(
                                                    item.node.growthTask.id
                                                )
                                            "
                                        >
                                            <v-icon>launch</v-icon>
                                        </v-btn>
                                        <!-- <v-icon small @click="onDeletingTask(item.node)">delete</v-icon> -->
                                    </template>
                                </v-data-table>
                            </v-container>
                        </v-card>
                    </template>
                </v-hover>
            </v-col>
        </v-row>
    </v-container>
</template>

<script>
import gql from "graphql-tag";
import GrowthTaskDetailComponent from "@/components/growth/GrowthTaskDetailComponent.vue";
import moment from "moment";

export default {
    name: "order-cart-preview-list",
    props: ["salesOrderPlantNodeId", "loading"],
    components: {
        GrowthTaskDetailComponent
    },

    apollo: {
        salesOrderPlant: {
            query: gql`
                query salesOrderPlant($id: ID!) {
                    salesOrderPlant(id: $id) {
                        id
                        quantity
                        salesOrderGrowthTaskSet {
                            edges {
                                node {
                                    id
                                    quantity
                                    growthTask {
                                        id
                                        growthStartDate
                                        growthEndDate
                                        salesStartDate
                                        salesEndDate
                                        isReadyToSell
                                        note
                                        plant {
                                            id
                                            name
                                            plantSpecies {
                                                id
                                                name
                                            }
                                        }
                                        potSize {
                                            id
                                            potSizeCm
                                        }
                                        color {
                                            id
                                            color
                                        }
                                        environment {
                                            id
                                            environment
                                        }
                                        tag {
                                            id
                                            tag
                                        }
                                        totalInventory
                                        currentGrowthTaskPhase {
                                            id
                                            greenhouseDepartmentSection {
                                                id
                                                name
                                                greenhouseDepartment {
                                                    id
                                                    name
                                                    greenhouse {
                                                        id
                                                        name
                                                    }
                                                }
                                            }
                                        }
                                    }
                                }
                            }
                        }
                    }
                }
            `,
            variables() {
                return {
                    id: this.salesOrderPlantNodeId
                };
            },
            // Additional options here
            fetchPolicy: "cache-and-network",
            update(data) {
                //send data to parent component
                this.$emit("item-fetched", data.salesOrderPlant);

                // console.log(data.salesOrderPlant);

                // this.$emit("update:loading", false);

                //return result to current componet
                return data.salesOrderPlant;
            },
            // watchLoading(isLoading) {
            //     this.$emit("update:loading", isLoading);
            //     // isLoading is a boolean
            //     // countModifier is either 1 or -1
            // },
            // skip() {
            //     return !this.salesOrderPlantNodeId;
            // },
            pollInterval: 60000 // ms
        }
    },

    data() {
        return {
            // isLoadingOrder: false,
            growthTaskDialog: false,

            selectedGrowthTaskNodeId: null,

            salesOrderPlant: { salesOrderGrowthTaskSet: [] },

            headers: [
                {
                    text: "Department",
                    value: "departement",
                    sortable: true
                },
                {
                    text: "Plant",
                    value: "node.growthTask.plant.name",
                    sortable: true
                },
                {
                    text: "Start Week",
                    value: "node.growthTask.growthStartDate",
                    sortable: true
                },
                {
                    text: "Note",
                    value: "node.growthTask.note",
                    sortable: true
                },
                {
                    text: "Pot Size",
                    value: "node.growthTask.potSize.potSizeCm",
                    sortable: true
                },
                {
                    text: "Color",
                    align: "left",
                    value: "node.growthTask.color.color",
                    sortable: true
                },
                {
                    text: "Environment",
                    value: "node.growthTask.environment.environment",
                    sortable: true
                },
                {
                    text: "Tag",
                    value: "node.growthTask.tag.tag",
                    sortable: true
                },
                {
                    text: "Quantity",
                    value: "node.quantity",
                    align: "center",
                    sortable: true
                },
                {
                    text: "Actions",
                    value: "action",
                    width: "120px",
                    align: "center",
                    sortable: false
                }
            ]
        };
    },
    computed: {
        // salesOrder() {
        //     return this.salesOrderCart.salesOrder || {};
        // },
        // orderCartProducts() {
        //     return this.salesOrderCart.salesOrderProductCartSet
        //         ? this.salesOrderCart.salesOrderProductCartSet.edges
        //         : [];
        // },
        isLoading() {
            return this.$apollo.queries.salesOrderPlant.loading;
        }
    },
    watch: {},
    created() {
        // this.initialize();
    },
    mounted() {},
    methods: {
        calculateDaysBetweenDays(day1, day2) {
            return moment(day1).diff(moment(day2), "day");
        },

        openGrowthTaskDialog(growthTask) {
            this.selectedGrowthTaskNodeId = growthTask.id;
            this.growthTaskDialog = true;
        },

        closeGrowthTaskDialog() {
            this.growthTaskDialog = false;
            this.selectedGrowthTaskNodeId = null;
            this.$apollo.queries.salesOrderPlant.refresh();
        },

        goToGrowthTaskDetail(growthTaskNodeId) {
            let routeData = this.$router.resolve({
                name: "growthtask-detail",
                params: { id: growthTaskNodeId }
            });
            window.open(routeData.href, "_blank");
        },

        refreshGrowthTaskList() {
            this.$apollo.queries.salesOrderPlant.refresh();
        },

        onGrowthTaskDeleted() {
            this.$apollo.queries.salesOrderPlant.refresh();
        }
    }
};
</script>
